import {postRequest, postRequestFile} from "../../utils/api"

export const getDoctorBasePageList = (params) => {
    return postRequest('/core/doctor/base/list',params)
}

export const addDoctorBase = (params) => {
    return postRequest('/core/doctor/base/add',params)
}

export const updateDoctorBase = (params) => {
    return postRequest('/core/doctor/base/update',params)
}

export const deleteDoctorBase = (params) => {
    return postRequest('/core/doctor/base/delete',params)
}


export const updatePassWord = (params) => {
    return postRequest('/core/doctor/base/updatePassWord',params)
}

//上传医生数据
export const uploadDoctorData = (params) => {
    return postRequestFile('/core/doctor/base/uploadData',params)
}